<template>
  <div id="app">
    <el-row>
      <el-col :span="24">
        <el-container>
          <el-header v-if="showHeader">
            <app-header :login="login"></app-header>
          </el-header>
          <el-main id="app-main">
            <router-view @message="message"/>
          </el-main>
          <el-footer v-if="showFooter" height="30px">
            <app-footer></app-footer>
          </el-footer>
        </el-container>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader/AppHeader'
import AppFooter from '@/components/AppFooter/AppFooter'
export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  data () {
    return {
      login: false,
      showHeader: true,
      showFooter: true
    }
  },
  methods: {
    message (res) {
      if (res.login) {
        this.login = true
      }
      // eslint-disable-next-line
      if (res.showHeader != true) {
        this.showHeader = false
      } else {
        this.showHeader = true
      }
      // eslint-disable-next-line
      if (res.showFooter != true) {
        this.showFooter = false
      } else {
        this.showFooter = true
      }
    }
  }
}
</script>
<style scoped>
#app {
  width: 1170px;
  margin: 0 auto;
}
#app-main {
  min-height: 860px;
}
</style>
<style>
.el-input .el-input__inner{
   border-top: 0px !important;
   border-left: 0px !important;
   border-right: 0px !important;
   color:  #323336;
   border-bottom: 1px solid #ccc;
   border-radius: 0;
   padding-left: 0;
   background: rgba(0,0,0,0);
}
.el-input .el-input__inner::-webkit-input-placeholder {
  color: #323336;
  padding-left: 0;
}
.el-input .el-input__inner::-moz-input-placeholder {
  color: #323336;
  padding-left: 0;
}
.el-input .el-input__inner::-ms-input-placeholder {
  color: #323336;
  padding-left: 0;
}
.el-form-item .el-form-item__label{
  display: block !important;
  width: 100% !important;
  text-align: left !important;
  line-height: 20px;
}
.el-form-item  .el-form-item__content{
  margin-left: 0px !important;
  line-height: 20px;
}
.el-button, .el-button--primary{
    font-weight: bold;
    background: linear-gradient(45deg, #ff7f00 0%, #ffb100 100%);
    border-radius: 50px;
    border: none !important;
    color: #FFF !important;
    width: 145px;
    line-height: 20px;
    display: inline-block;
    box-shadow: 0 10px 20px -5px rgb(246 179 26 / 90%);
    text-align: center;
    font-family: "Poppins", Arial, Helvetica, sans-serif;
    font-size: 13px;
    transition: all 0.3s ease 0s;
}
.el-button:hover, .el-button--primary:hover {
    transform: translateY(1px);
    box-shadow: 0 3px 10px -5px rgb(246 179 26 / 90%);
    background-position: -145px;
    background-color: #ff7f00;
    color: #fff;
    transition: all 0.3s ease 0s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue